
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/forms.module.scss';

import type { IFormWrapper } from './types';

const FormWrapper = (
  {
    backgroundColor,
    children,
    fullWidth,
    logo,
    inHero,
  }: IFormWrapper) => {
  if (inHero) {
    return <div className={generateClassName(['inHeroContainer', styles.inHeroContainer, fullWidth ? styles.fullWidth : ''])}>{children}</div>;
  }

  return (
    <>
      <div
        className={generateClassName(['grid', styles.formGrid])}
        style={{ color: backgroundColor === 'light' ? 'var(--color-charcoal)' : 'var(--color-white)' }}
      >
        <div className={styles.logoWrapper}>
          {logo}
        </div>
        <div className={styles.modalContent}>
          <div className={styles.formArea}>
            {children}
          </div>
        </div>
      </div>
      <div className={styles.bottomTriangle} />
    </>
  );
};

export default FormWrapper;
